import { useEffect } from 'react';
import { useCalendarEvents } from './useCalendarEvents';

/**
 * Fetch event data for a single ISO date. Same shape as the original
 * `DayDataLoader` component used to push up via `onResult`.
 */
export function useDayData(dateISO) {
  const { eventsByCalendar, loading, error } = useCalendarEvents(dateISO);
  return { dateISO, eventsByCalendar, loading, error };
}

/**
 * Headless wrapper used inside `days.map(...)` to call `useDayData` once
 * per visible day and push the result up to the parent's accumulator.
 *
 * React's rules-of-hooks require a stable hook count per render — that's
 * why we render N copies of this wrapper instead of calling `useDayData`
 * inside a loop in the parent.
 */
export function DayDataSlot({ date, refreshKey, onResult }) {
  const result = useDayData(date.toISODate());
  useEffect(() => {
    onResult(result.dateISO, {
      eventsByCalendar: result.eventsByCalendar,
      loading: result.loading,
      error: result.error,
    });
  }, [result.dateISO, result.eventsByCalendar, result.loading, result.error, onResult, refreshKey]);
  return null;
}
